import { featureFlagClient } from '../core/featureFlagClient';

export function publishFeatureFlagsBridge(): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.fdFeatureFlags ??= featureFlagClient;
}
